import React, { useEffect, lazy, Suspense } from "react";
import axios from 'axios';
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import HamakomSuites from './components/hamakom_web';
import CookieConsentBanner from './components/CookieConsent';
import { initReveal } from './effects/reveal';
import { initSmoothScroll } from './effects/smoothScroll';

// Secondary pages are code-split so the first visit only downloads the homepage bundle
const LuxurySuites = lazy(() => import('./components/LuxurySuites'));
const LuxuryVips = lazy(() => import('./components/LuxuryVips'));
const VirtualTour = lazy(() => import('./components/VirtualTour'));
const LuxuryVilla = lazy(() => import('./components/LuxuryVilla'));
const LuxuryDomi = lazy(() => import('./components/LuxuryDomi'));
const Negishot = lazy(() => import('./components/Negishot'));
const Tos = lazy(() => import('./components/Tos'));
const Kosher = lazy(() => import('./components/Kosher'));
const Restaurants = lazy(() => import('./components/Restaurants'));
const ChatApp = lazy(() => import('./components/gpt'));
const GetEmbeddings = lazy(() => import('./components/get_embeddings'));


function App() {

  // Gentle scroll-reveal animations site-wide (skipped for reduced-motion users)
  useEffect(() => {
    initReveal();
    initSmoothScroll();
  }, []);

  // Microsoft Clarity - injected once on mount (was previously re-injected on every render)
  useEffect(() => {
    if (window.clarity) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "j3m7vz6stj");
    `;
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    const session_id = sessionStorage.getItem("session_id");
    if (!session_id) {
      const sessid = async () => {
        try {
            var domaino;
            if (process.env.NODE_ENV === 'development') {
               domaino = 'http://localhost:8080/chatapp/get_session/';
            } else {
               domaino = 'https://polls-service-6qrvcljmeq-uc.a.run.app/chatapp/get_session/';
            }
            const response_session = await axios.get(domaino);
            const session_id = response_session.data.session_id;
            sessionStorage.setItem("session_id", session_id);
        } catch (error) {
          console.error("Error getting session ID:", error);
        }
      };
      sessid();
    }
  }, []);

  return (
    <LanguageProvider>
    <HelmetProvider>
      <Router>
        <div className="App">
          {/* Add any head`er, footer, or other shared components here */}
          {/* <header className="App-header">
          <h1>ChatGPT Chat App</h1>
          </header>*/}
          <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
          <CookieConsentBanner />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/gpt" element={<ChatApp />} />
              <Route path="/" element={<HamakomSuites />} />
              <Route path="/LuxurySuites" element={<LuxurySuites />} />
              <Route path="/LuxuryVips" element={<LuxuryVips />} />
              <Route path="/LuxuryVilla" element={<LuxuryVilla />} />
              <Route path="/LuxuryDomi" element={<LuxuryDomi />} />

              <Route path="/Negishot" element={<Negishot />} />
              <Route path="/Tos" element={<Tos />} />
              <Route path="/Kosher" element={<Kosher />} />
              <Route path="/Restaurants" element={<Restaurants />} />

              <Route path="/VirtualTour" element={<VirtualTour />} />
              <Route path="/get-embeddings-model" element={<GetEmbeddings />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;
